import { handleRequest } from './requests'
import { STATE_KEYS } from '../state/requests'
import { put, take, fork, call } from 'redux-saga/effects'
import { PartipostApiPaginationWrapper } from 'services/api'
import {
    GetBannersRequest,
    getBannerGroups,
    getBanners,
    disableBanner,
    DisableBannerResponse,
    createBanner,
} from 'services/api/banners'
import {
    BannerManagerActions,
    BannerState,
    BannerGroupState,
    saveBannerGroups,
    saveBanners,
    DisableBannerPayload,
    updateBanner,
    CreateBannerPayload,
} from 'state/banners'
import i18n from '../config/i18n'
import { showSnackBar } from '../services/toast'
import { PartipostApiError } from 'services/api/errors'

export function* handleGetBannerGroups(): any {
    yield handleRequest<Record<string, never>, PartipostApiPaginationWrapper<BannerGroupState[]>>({
        stateKey: STATE_KEYS.GetBannerGroups,
        payload: {},
        ApiHandler: getBannerGroups,
        *onSuccess(response) {
            yield put(
                saveBannerGroups(
                    response.data && response.data.data && response.data.data.results && response.data.data.results,
                ),
            )
        },
    })
}

export function* watchGetBannerGroupsRequestFlow(): any {
    while (true) {
        yield take(BannerManagerActions.BANNER_GROUPS_REQUEST)
        yield fork(handleGetBannerGroups)
    }
}

export function* handleGetBanners(payload: GetBannersRequest): any {
    yield handleRequest<GetBannersRequest, PartipostApiPaginationWrapper<BannerState[]>>({
        stateKey: STATE_KEYS.GetBanners,
        payload,
        ApiHandler: getBanners,
        *onSuccess(response) {
            yield put(
                saveBanners(
                    response.data && response.data.data && response.data.data.results && response.data.data.results,
                ),
            )
        },
    })
}

export function* watchGetBannersRequestFlow(): any {
    while (true) {
        const action = yield take(BannerManagerActions.BANNERS_REQUEST)
        yield fork(handleGetBanners, action.payload)
    }
}

export function* handleDisableBanner(payload: DisableBannerPayload): any {
    yield handleRequest<DisableBannerPayload, DisableBannerResponse>({
        stateKey: STATE_KEYS.DisableBanner,
        payload,
        ApiHandler: disableBanner,
        *onSuccess(response) {
            showSnackBar({
                title: i18n.t('successMessage.bannerDisabledTitle'),
                type: 'positive',
            })
            yield put(updateBanner(response.data && response.data.data && response.data.data))
        },
        *onError() {
            showSnackBar({
                title: i18n.t('errorMessage.general.unknownError'),
                type: 'error',
            })
        },
    })
}

export function* watchDisableBannersRequestFlow(): any {
    while (true) {
        const action = yield take(BannerManagerActions.DISABLE_BANNER_REQUEST)
        yield fork(handleDisableBanner, action.payload)
    }
}

export function* handleCreateBanner(payload: CreateBannerPayload): any {
    yield handleRequest<CreateBannerPayload, BannerState>({
        stateKey: STATE_KEYS.CreateBanner,
        payload,
        ApiHandler: createBanner,
        *onSuccess(response) {
            showSnackBar({
                title: i18n.t('successMessage.bannerCreatedSubtitle'),
                type: 'positive',
            })
            yield put(updateBanner(response.data && response.data.data && response.data.data))
            yield call(payload.callback)
        },
        *onError(err: unknown) {
            const errorResp = err as PartipostApiError
            // trigger callback with params (err code), for formik field error
            // already handled if errorResp.validation_errors?.code is undefined
            yield call(() => payload.callback(errorResp.validation_errors?.code))

            showSnackBar({
                title: i18n.t('errorMessage.general.unknownError'),
                type: 'error',
            })
        },
    })
}

export function* watchCreateBannersRequestFlow(): any {
    while (true) {
        const action = yield take(BannerManagerActions.CREATE_BANNER_REQUEST)
        yield fork(handleCreateBanner, action.payload)
    }
}
